import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Layout from './components/layout/Layout';
import ServiceOrders from './pages/Dashboard/ServiceOrders';
import SalesOrders from './pages/Dashboard/SalesOrders';
import CRMOpportunities from './pages/Dashboard/CRMOpportunities'; // 🆕 NOVO - Oportunidades CRM
import CRMBudgets from './pages/Dashboard/CRMBudgets'; // 🆕 NOVO - Orçamentos CRM

// Componente para rotas protegidas
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

// Componentes temporários para as páginas que ainda serão criadas
const FinancialDashboard = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h1 style={{ color: '#1f2937', marginBottom: '1rem' }}>Dashboard Financeiro</h1>
    <p style={{ color: '#6b7280', fontSize: '1.125rem' }}>
      Em desenvolvimento - Dashboard de análise financeira
    </p>
    <div style={{
      backgroundColor: '#f0f9ff',
      border: '1px solid #7dd3fc',
      borderRadius: '8px',
      padding: '1rem',
      marginTop: '2rem',
      maxWidth: '400px',
      margin: '2rem auto'
    }}>
      <p style={{ color: '#0369a1', margin: 0, fontSize: '0.875rem' }}>
        Funcionalidades planejadas:<br/>
        • Receitas e despesas<br/>
        • Gráficos de performance<br/>
        • Relatórios mensais<br/>
        • Análise de tendências
      </p>
    </div>
  </div>
);

const AnalyticsDashboard = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h1 style={{ color: '#1f2937', marginBottom: '1rem' }}>Dashboard de Análises</h1>
    <p style={{ color: '#6b7280', fontSize: '1.125rem' }}>
      Em desenvolvimento - Dashboard de análises avançadas
    </p>
    <div style={{
      backgroundColor: '#f0f9ff',
      border: '1px solid #7dd3fc',
      borderRadius: '8px',
      padding: '1rem',
      marginTop: '2rem',
      maxWidth: '400px',
      margin: '2rem auto'
    }}>
      <p style={{ color: '#0369a1', margin: 0, fontSize: '0.875rem' }}>
        Funcionalidades planejadas:<br/>
        • KPIs principais<br/>
        • Análise de performance<br/>
        • Previsões e tendências<br/>
        • Relatórios customizados
      </p>
    </div>
  </div>
);

const IntegrationsPage = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h1 style={{ color: '#1f2937', marginBottom: '1rem' }}>Integrações</h1>
    <p style={{ color: '#6b7280', fontSize: '1.125rem' }}>
      Em desenvolvimento - Gestão de integrações
    </p>
    <div style={{
      backgroundColor: '#f0f9ff',
      border: '1px solid #7dd3fc',
      borderRadius: '8px',
      padding: '1rem',
      marginTop: '2rem',
      maxWidth: '400px',
      margin: '2rem auto'
    }}>
      <p style={{ color: '#0369a1', margin: 0, fontSize: '0.875rem' }}>
        Funcionalidades planejadas:<br/>
        • Configurar APIs<br/>
        • Monitorar conexões<br/>
        • Logs de sincronização<br/>
        • Webhooks e automações
      </p>
    </div>
  </div>
);

const SettingsPage = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h1 style={{ color: '#1f2937', marginBottom: '1rem' }}>Configurações</h1>
    <p style={{ color: '#6b7280', fontSize: '1.125rem' }}>
      Em desenvolvimento - Configurações do sistema
    </p>
    <div style={{
      backgroundColor: '#f0f9ff',
      border: '1px solid #7dd3fc',
      borderRadius: '8px',
      padding: '1rem',
      marginTop: '2rem',
      maxWidth: '400px',
      margin: '2rem auto'
    }}>
      <p style={{ color: '#0369a1', margin: 0, fontSize: '0.875rem' }}>
        Funcionalidades planejadas:<br/>
        • Perfil de usuário<br/>
        • Configurações de empresa<br/>
        • Preferências do sistema<br/>
        • Backup e restauração
      </p>
    </div>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <div style={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Routes>
                      {/* Dashboard Routes */}
                      <Route path="/dashboard/service-orders" element={<ServiceOrders />} />
                      <Route path="/dashboard/sales-orders" element={<SalesOrders />} />
                      
                      {/* 🆕 CRM Routes - NOVOS MÓDULOS */}
                      <Route path="/dashboard/crm-opportunities" element={<CRMOpportunities />} />
                      <Route path="/dashboard/crm-budgets" element={<CRMBudgets />} />
                      
                      <Route path="/dashboard/financial" element={<FinancialDashboard />} />
                      <Route path="/dashboard/analytics" element={<AnalyticsDashboard />} />
                      
                      {/* Other Routes */}
                      <Route path="/integrations" element={<IntegrationsPage />} />
                      <Route path="/settings" element={<SettingsPage />} />
                      
                      {/* Redirect root and dashboard to service orders */}
                      <Route path="/" element={<Navigate to="/dashboard/service-orders" />} />
                      <Route path="/dashboard" element={<Navigate to="/dashboard/service-orders" />} />
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;